import { Injectable } from '@angular/core';
import { AmdocsAppsyncClientService } from 'amdocs-auth-package';
import { Observable } from 'rxjs';
import * as AmdocsContentConstant from '../content.constants';
import { ApiService } from './api.service';
import { UiStateService } from './ui-state.service';

@Injectable({
  providedIn: 'root'
})
export class EmpDetailsService {
  private amdocsContentConstant: any = AmdocsContentConstant;
  constructor(private appSyncClient: AmdocsAppsyncClientService,
              private uiStateService: UiStateService,
              private apiService: ApiService) {

  }

  public getUserDetails(uuid: string): Observable<EmployeeDetails> {
    const fromSearch = this.uiStateService.get('fromSearch');
    const skipHistory = !fromSearch;
    this.uiStateService.set('fromSearch', null);
    return this.apiService.getEmployeeDetails(uuid, skipHistory);
  }

  public getSocialActions(employeeDetails: EmployeeDetails): ISocialButtons {
    return  {
      right: {
        title: this.amdocsContentConstant?.socialButtons?.teams,
        icon: '/assets/icons/teams-icon.svg',
        chat: employeeDetails.chatTeamsUrl
      },
      left: {
        title: this.amdocsContentConstant?.socialButtons?.skype,
        icon: '/assets/icons/skype-icon.svg',
        call: employeeDetails.callSkypeUrl,
        chat: employeeDetails.chatSkypeUrl
      }
    };
  }
}

export interface EmployeeDetails {
  id: string;
  displayName: string;
  mail: string;
  userPrincipalName: string;
  jobTitle: string;
  mobilePhone: string;
  officeLocation: string;
  state: string;
  department: string;
  userType: string;
  employeeId: string;
  country: string;
  city: string;
  chatTeamsUrl: string;
  callSkypeUrl: string;
  chatSkypeUrl: string;
}


export interface ISocialButtons {
  left: ISocialActions;
  right: ISocialActions;
}

export interface ISocialActions {
  icon: string;
  title: string;
  call?: string;
  chat: string;
}
